import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './navbar/navbar.component';
import { QuestComponent } from './quest/quest.component';
import { TitleComponent } from './quest/title/title.component';
import { ScoreComponent } from './quest/score/score.component';
import { QuestItemsComponent } from './quest/quest-items/quest-items.component';
import { QuestItemComponent } from './quest/quest-item/quest-item.component';
import { LoginComponent } from './login/login.component';
import { LeaderBoardComponent } from './leaderBoard/leader-board.component';
import { LoadingComponent } from './quest/loading/loading.component';
import { InfoComponent } from './quest/info/info.component';
import { ScheduleComponent } from './schedule/schedule.component';
import { WelcomeComponent } from './welcome/welcome.component';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    QuestComponent,
    TitleComponent,
    ScoreComponent,
    QuestItemsComponent,
    QuestItemComponent,
    LoginComponent,
    LeaderBoardComponent,
    LoadingComponent,
    InfoComponent,
    ScheduleComponent,
    WelcomeComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    FontAwesomeModule,
    HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { 
}
